document.addEventListener('DOMContentLoaded', function () {
    var scrollIcon = document.getElementById('scroll-icon');
    var textDescription = document.getElementById('text-description');

    if (scrollIcon && textDescription) {
      scrollIcon.addEventListener('click', function () {
        var isCollapsed = textDescription.classList.contains('collapsed');
        if (isCollapsed) {
          textDescription.classList.remove('collapsed');
          scrollIcon.classList.add('expanded');
          scrollIcon.setAttribute('aria-expanded', 'true');
          scrollIcon.setAttribute('aria-label', 'Colapsar texto');
        } else {
          textDescription.classList.add('collapsed');
          scrollIcon.classList.remove('expanded');
          scrollIcon.setAttribute('aria-expanded', 'false');
          scrollIcon.setAttribute('aria-label', 'Expandir texto');
        }
      });
      scrollIcon.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          scrollIcon.click();
        }
      });
    }
  });